<script lang="ts">
    import { onMount } from "svelte"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import { animateOnVisible } from "../../../../configs/config"

    let { entries }: { entries: ImageEntry[] } = $props()
    let listEls = $state([])
    let style = $state("")
    onMount(() => {
        const transformProps: any = []
        if (listEls.length == 1) {
            transformProps.push({
                translateY: ["-50px", "0rem"],
            })
        } else if (listEls.length == 2) {
            transformProps.push({
                translateY: ["50px", "0rem"],
                translateX: ["-50px", "0rem"],
            })
            transformProps.push({
                translateY: ["50px", "0rem"],
                translateX: ["50px", "0rem"],
            })
        } else if (listEls.length == 3) {
            transformProps.push({
                translateY: ["50px", "0rem"],
                translateX: ["-50px", "0rem"],
            })
            transformProps.push({
                translateY: ["50px", "0rem"],
            })
            transformProps.push({
                translateY: ["50px", "0rem"],
                translateX: ["50px", "0rem"],
            })
        }
        let intervals = []
        listEls.forEach((el, i) => {
            animateOnVisible(el, {
                delay: i * 50,
                duration: 300,
                opacity: [0, 1],
                easing: "cubicBezier",
                ...transformProps?.[i],
            })
            const EPS = 1e-3

            function translationIsZero(el: Element, eps = EPS): boolean {
                const tr = getComputedStyle(el).transform // "none" | "matrix(a,b,c,d,tx,ty)" | "matrix3d(...)"
                if (tr === "none") return true // bereits Identität

                let m: DOMMatrix
                try {
                    m = new DOMMatrix(tr)
                } catch {
                    // Fallback: rohe Strings parsen (selten nötig)
                    const m2d = tr.match(/matrix\(([^)]+)\)/)
                    const m3d = tr.match(/matrix3d\(([^)]+)\)/)
                    if (m2d) {
                        const v = m2d[1].split(",").map(Number)
                        const tx = v[4] ?? 0,
                            ty = v[5] ?? 0
                        return Math.abs(tx) <= eps && Math.abs(ty) <= eps
                    }
                    if (m3d) {
                        const v = m3d[1].split(",").map(Number)
                        const tx = v[12] ?? 0,
                            ty = v[13] ?? 0
                        return Math.abs(tx) <= eps && Math.abs(ty) <= eps
                    }
                    return false
                }
                return Math.abs(m.m41) <= eps && Math.abs(m.m42) <= eps
            }

            const id = setInterval(() => {
                if (translationIsZero(el)) {
                    ;(el as HTMLElement).style.transform = "none"
                    clearInterval(id)
                }
            }, 500)
            intervals.push(id)
        })
        return () => {
            intervals.forEach(clearInterval)
        }
    })
</script>

<ul class="gallery-row items-{entries.length}">
    {#each entries as item, idx}
        <li class="gallery-item {item.captionposition} {item.imagesize}" {style} bind:this={listEls[idx]}>
            <MedialibImage id={item.image[0]} maxWidth={1100} modalable={true} />
            <p class="text">{item.caption}</p>
        </li>
    {/each}
</ul>
